import { webDataLoading, webDataNotAsked, webDataSuccess, serializedErrorToWebDataError } from "@lvt/web-data";
import { createSlice } from "@reduxjs/toolkit";

import { fetchLiveUnits } from "@/api/map/liveUnits/liveUnits";
import { RootState } from "@/store";
import { LiveUnitState } from "@/store/map/liveUnits/types";


const initialState: LiveUnitState = {
    liveUnits: webDataNotAsked(),
};

export const liveUnitsSlice = createSlice({
    name: "liveUnits",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchLiveUnits.pending, (state) => {
                state.liveUnits = webDataLoading();
            })
            .addCase(fetchLiveUnits.fulfilled, (state, action) => {
                state.liveUnits = webDataSuccess(action.payload);
            })
            .addCase(fetchLiveUnits.rejected, (state, action) => {
                state.liveUnits = serializedErrorToWebDataError(action.error);
            });
    },
});

export const liveUnitsReducer = liveUnitsSlice.reducer;
export const liveUnitsSelectors = {
    getLiveUnits: (state: RootState) => {
        return state.mapLiveUnits.liveUnits;
    },
};
